const BLOCKED_USER_AGENTS = [
  'sqlmap',
  'nikto',
  'nessus',
  'acunetix',
  'netsparker',
  'burpsuite',
  'owasp',
  'w3af',
  'dirbuster',
  'gobuster',
  'wfuzz',
  'ffuf',
  'nuclei',
  'httpx',
  'masscan',
  'zgrab',
  'censys',
  'shodan',
  'python-requests',
  'python-urllib',
  'go-http-client',
  'curl/',
  'wget/',
  'scrapy',
  'phantomjs',
  'headlesschrome',
  'selenium',
  'puppeteer',
  'playwright',
  'webdriver',
  'httpclient',
  'java/',
  'libwww-perl',
  'lwp-',
  'mechanize',
  'arachni',
  'vega/',
  'skipfish',
  'wapiti',
  'zap/',
  'havij',
  'commix',
  'xsstrike',
  'dalfox',
];

const ALLOWED_BOTS = [
  'googlebot',
  'bingbot',
  'slurp',
  'duckduckbot',
  'baiduspider',
  'yandexbot',
  'facebookexternalhit',
  'twitterbot',
  'linkedinbot',
  'slackbot',
  'discordbot',
  'telegrambot',
  'whatsapp',
  'applebot',
];

export function isBlockedUserAgent(userAgent: string | null): boolean {
  if (!userAgent || userAgent.trim() === '') {
    return true;
  }

  const ua = userAgent.toLowerCase();

  for (const allowed of ALLOWED_BOTS) {
    if (ua.includes(allowed)) {
      return false;
    }
  }

  for (const blocked of BLOCKED_USER_AGENTS) {
    if (ua.includes(blocked.toLowerCase())) {
      return true;
    }
  }

  return false;
}

export function getUserAgentRiskScore(userAgent: string | null): number {
  if (!userAgent || userAgent.trim() === '') {
    return 80;
  }

  const ua = userAgent.toLowerCase();
  let score = 0;

  for (const blocked of BLOCKED_USER_AGENTS) {
    if (ua.includes(blocked.toLowerCase())) {
      score += 50;
      break;
    }
  }

  if (ua.length < 20) {
    score += 20;
  }

  if (!/mozilla|chrome|safari|firefox|edge|opera/i.test(ua)) {
    score += 15;
  }

  if (!/windows|macintosh|linux|android|iphone|ipad/i.test(ua)) {
    score += 15;
  }

  return Math.min(score, 100);
}

export function getBlockedUserAgentList(): string[] {
  return [...BLOCKED_USER_AGENTS];
}
